import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GoldSyncService } from '../gold-sync.service';
import { isSchedulerCallSuccess, unwrapSchedulerResponse } from '../gold-sync-response.util';

export interface GoldSyncTableDetailsDialogData {
  baseUrl: string;
  tableName: string;
}

@Component({
  selector: 'gtw-gold-sync-table-details-dialog',
  templateUrl: './gold-sync-table-details-dialog.component.html',
  styleUrls: ['./gold-sync-table-details-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GoldSyncTableDetailsDialogComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  dataLoading = true;
  displayTaxYear = true;
  simpleLayout = false;
  objectDataCount: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<GoldSyncTableDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GoldSyncTableDetailsDialogData,
    private goldSyncService: GoldSyncService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.goldSyncService.getGoldSyncObjectDataCount(this.data.baseUrl, this.data.tableName).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        const data = unwrapSchedulerResponse(response);
        if (isSchedulerCallSuccess(data['callSuccess'])) {
          this.displayTaxYear = data['displayTaxYear'] !== false;
          this.objectDataCount = (data['goldSyncObjDataCount'] as unknown[]) || [];
          this.objectDataCount.sort((a, b) =>
            parseInt(b.tax_year, 10) > parseInt(a.tax_year, 10) ? 1 : -1
          );
          this.simpleLayout =
            this.objectDataCount.length === 1 && this.objectDataCount[0].tax_year == null;
        } else {
          this.objectDataCount = [];
        }
        this.dataLoading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.objectDataCount = [];
        this.dataLoading = false;
        this.cdr.markForCheck();
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
